"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolesScreen = RolesScreen;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var react_router_dom_1 = require("react-router-dom");
var confirm_dialog_1 = require("../../components/common/confirm-dialog");
var data_table_1 = require("../../components/common/data-table");
var page_header_1 = require("../../components/common/page-header");
var permission_gate_1 = require("../../components/common/permission-gate");
var roles_1 = require("../../features/apis/roles");
var use_error_handler_1 = require("../../hooks/use-error-handler");
var permissions_1 = require("../../interfaces/permissions");
function PlusIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-4 w-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 4v16m8-8H4" }) }));
}
function RolesScreen() {
    var _this = this;
    var _a, _b, _c;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _d = (0, use_error_handler_1.useErrorHandler)(), handleError = _d.handleError, handleSuccess = _d.handleSuccess;
    var _e = (0, react_2.useState)(1), page = _e[0], setPage = _e[1];
    var _f = (0, react_1.useDisclosure)(), isDeleteOpen = _f.isOpen, onDeleteOpen = _f.onOpen, onDeleteClose = _f.onClose;
    var _g = (0, react_2.useState)(null), deletingRole = _g[0], setDeletingRole = _g[1];
    var _h = (0, roles_1.useGetRolesQuery)({
        page: page,
        limit: 10,
    }), data = _h.data, isLoading = _h.isLoading, isFetching = _h.isFetching;
    var _j = (0, roles_1.useDeleteRoleMutation)(), deleteRole = _j[0], isDeleting = _j[1].isLoading;
    var roles = ((_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.roles) || [];
    var totalPages = ((_c = (_b = data === null || data === void 0 ? void 0 : data.content) === null || _b === void 0 ? void 0 : _b.pagination) === null || _c === void 0 ? void 0 : _c.total_pages) || 1;
    var columns = [
        {
            key: "name",
            label: "Name",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "font-medium text-foreground", children: item.name }); },
        },
        {
            key: "code",
            label: "Code",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "rounded bg-default-100 px-2 py-1 text-xs font-mono", children: item.code }); },
        },
        {
            key: "description",
            label: "Description",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: item.description || "-" }); },
        },
        {
            key: "permissions",
            label: "Permissions",
            render: function (item) { var _a; return (0, jsx_runtime_1.jsxs)("span", { className: "text-default-500", children: [((_a = item.permissions) === null || _a === void 0 ? void 0 : _a.length) || 0, " modules"] }); },
        },
        {
            key: "actions",
            label: "Actions",
            align: "end",
            render: function (item) { return ((0, jsx_runtime_1.jsxs)("div", { className: "flex justify-end gap-2", children: [(0, jsx_runtime_1.jsx)(permission_gate_1.PermissionGate, { module: permissions_1.MODULES.ROLES, action: permissions_1.ACTIONS.UPDATE, children: (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "primary", onPress: function () { return navigate("/roles/".concat(item._id, "/edit")); }, isDisabled: item.code === "admin", children: "Edit" }) }), (0, jsx_runtime_1.jsx)(permission_gate_1.PermissionGate, { module: permissions_1.MODULES.ROLES, action: permissions_1.ACTIONS.DELETE, children: (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "danger", onPress: function () { return handleDeleteClick(item); }, isDisabled: item.code === "admin", children: "Delete" }) })] })); },
        },
    ];
    var handleDeleteClick = function (role) {
        setDeletingRole(role);
        onDeleteOpen();
    };
    var handleDelete = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!deletingRole)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteRole(deletingRole._id).unwrap()];
                case 2:
                    _a.sent();
                    handleSuccess("Role deleted successfully");
                    onDeleteClose();
                    setDeletingRole(null);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    handleError(error_1, { defaultMessage: "Failed to delete role" });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "space-y-6", children: [(0, jsx_runtime_1.jsx)(page_header_1.PageHeader, { title: "Roles", description: "Manage user roles and permissions", actions: [
                    {
                        label: "Add Role",
                        icon: (0, jsx_runtime_1.jsx)(PlusIcon, {}),
                        href: "/roles/new",
                    },
                ] }), (0, jsx_runtime_1.jsx)(data_table_1.DataTable, { columns: columns, data: roles, isLoading: isLoading || isFetching, page: page, totalPages: totalPages, onPageChange: setPage, emptyContent: "No roles found" }), (0, jsx_runtime_1.jsx)(confirm_dialog_1.ConfirmDialog, { isOpen: isDeleteOpen, onClose: onDeleteClose, onConfirm: handleDelete, title: "Delete Role", message: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Are you sure you want to delete the role ", (0, jsx_runtime_1.jsx)("strong", { children: deletingRole === null || deletingRole === void 0 ? void 0 : deletingRole.name }), "? This action cannot be undone."] }), confirmLabel: "Delete", confirmColor: "danger", isLoading: isDeleting })] }));
}
